import React from "react";
import ListContent from "../../components/ListContent";
import IconContent from "../../components/IconContent";
import QuoteContent from "../../components/QuoteContent";
import TextContent from "../../components/TextContent";
import TwoImagesContent from "../../components/TwoImagesContent";
import HeroContent from "../../components/HeroContent";
import HeroMedia from "../../components/HeroMedia";
import LargeImageContent from "../../components/Large-Image-Content";
import TableContent from "../../components/Table-Content";
import TableHighlight from "../../components/TableHighlight";

const TabMenuWrapper = ({ children }) => {
  const { fields } = children;
  switch (fields.componentName.value) {
    case "ListContent":
      return (
        <ListContent fields={fields} rendering={{ dataSource: children.id }} />
      );
    case "IconContent":
      return (
        <IconContent fields={fields} rendering={{ dataSource: children.id }} />
      );
    case "QuoteContent":
      return (
        <QuoteContent fields={fields} rendering={{ dataSource: children.id }} />
      );
    case "TextContent":
      return (
        <TextContent fields={fields} rendering={{ dataSource: children.id }} />
      );
    case "TwoImagesContent":
      return (
        <TwoImagesContent
          fields={fields}
          rendering={{ dataSource: children.id }}
        />
      );
    case "HeroContent":
      return (
        <HeroContent fields={fields} rendering={{ dataSource: children.id }} />
      );
    case "HeroMedia":
      return (
        <HeroMedia fields={fields} rendering={{ dataSource: children.id }} />
      );
    case "Large-Image-Content":
      return (
        <LargeImageContent
          fields={fields}
          rendering={{ dataSource: children.id }}
        />
      );
    case "Table-Content":
      return (
        <TableContent fields={fields} rendering={{ dataSource: children.id }} />
      );
    case "TableHighlight":
      return (
        <TableHighlight
          fields={fields}
          rendering={{ dataSource: children.id }}
        />
      );
    default:
      return "";
  }
};

export default TabMenuWrapper;
